import { render, staticRenderFns } from "./SidebarSharePlugin.vue?vue&type=template&id=78da401b&scoped=true&"
import script from "./SidebarSharePlugin.vue?vue&type=script&lang=js&"
export * from "./SidebarSharePlugin.vue?vue&type=script&lang=js&"
import style0 from "./SidebarSharePlugin.vue?vue&type=style&index=0&id=78da401b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78da401b",
  null
  
)

export default component.exports